import { SimplePage } from "@/app/_/marketing/SimplePage";

export default function Page() {
  return (
    <SimplePage
      eyebrow="Investment"
      title="Investors and partners."
      subtitle="Neoledger is backed by operators and investors who've built and scaled fintech products. If you're exploring a partnership or investment, we'd love to thread."
      primaryCta={{
        label: "Reach out",
        to: "/company/contact",
      }}
    />
  );
}
